import { useFormApi } from '@data-driven-forms/react-form-renderer';

type PageProps = {
  fields?: any[];
  title?: string;
};

export default function Page({ fields = [] }: Readonly<PageProps>) {
  const { renderForm } = useFormApi();

  return <div>{renderForm(fields)}</div>;
}
